
export default {
  root: {
    tableLayout: 'fixed'
  },
};
